import { PRE_SIGNUP_SUBSCRIPTION_KEY, SEND_EMAIL_VERIFICATION_CODE_ENDPOINT, VERIFY_EMAIL_VERIFICATION_CODE_ENDPOINT } from "../config/constants"

export const sendEmailVerificationCodeAPICall = async (email) => {
    try {
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': PRE_SIGNUP_SUBSCRIPTION_KEY
        },
        body: JSON.stringify({ email })
      }
      const response = await window.fetch(SEND_EMAIL_VERIFICATION_CODE_ENDPOINT, config)
      const responseOk = await response.status === 200
      return responseOk
    } catch (e) {
      console.error('ERROR: ', e)
      return e
    }
  }

  export const validateEmailVerificationCodeAPICall = async (email, verificationCode) => {
    try {
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': PRE_SIGNUP_SUBSCRIPTION_KEY
        },
        body: JSON.stringify({ email, code: verificationCode })
      }
      const response = await window.fetch(VERIFY_EMAIL_VERIFICATION_CODE_ENDPOINT, config)
      const responseOk = await response.status === 200
      return responseOk
    } catch (e) {
      console.error('ERROR: ', e)
      return e
    }
  }